<template>
  <div>
    <!-- Start Bradcaump area -->
    <div class="bradcaump_area bg_image--4">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="bradcaump_inner text-center">
              <h2 class="bradcaump-title">产品详情 Product Details</h2>
              <nav class="bradcaump-content">
                <b-link class="breadcrumb_item" to="/home">Home</b-link>
                <span class="brd-separetor">/</span>
                <b-link class="breadcrumb_item" to="/prod">Product</b-link>
                <span class="brd-separetor">/</span>
                <span class="breadcrumb_item active">Product Details</span>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Bradcaump area -->

    <!-- Start Single Product -->
    <div class="gm_single_product pt--50 pb--50 bg--white">
      <div class="container">
        <div class="row align-content-center">
          <div class="col-lg-4 col-12">
            <b-carousel
              id="carousel-1"
              v-model="slide"
              :interval="4000"
              controls
              fade
              img-width="200"
              indicators
              background="#fff"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
            >
              <!-- Slides with image only -->
              <b-carousel-slide v-for="item in prod_slideshow" :key="item.title" :img-src="$domainPrefix + item.thumb" style="width:100%; height: auto;"></b-carousel-slide>
            </b-carousel>
          </div>

          <div class="col-lg-8 col-12">
            <div class="single_product_inner">
              <h4>{{ prod_content.title }}</h4>

              <div class="price">
                <span class="new">{{ prod_content.spec }}</span>
              </div>

              <ul class="rating">
                <li><i class="fa fa-star"></i></li>
                <li><i class="fa fa-star"></i></li>
                <li><i class="fa fa-star"></i></li>
                <li><i class="fa fa-star"></i></li>
                <li class="off"><i class="fa fa-star"></i></li>
              </ul>

              <div class="pro_dtl">
                <p>{{ prod_content.abstract }}</p>
              </div>

              <div class="product_share">
                <span>分享 Share:</span>
                <ul class="social_share">
                  <li>
                    <a class="facebook" href="#"><i class="fa fa-facebook"></i></a>
                  </li>
                  <li>
                    <a class="twitter" href="#"><i class="fa fa-twitter"></i></a>
                  </li>
                  <li>
                    <a class="google-plus" href="#"><i class="fa fa-google-plus"></i></a>
                  </li>
                  <li>
                    <a class="rss" href="#"><i class="fa fa-rss"></i></a>
                  </li>
                  <li>
                    <a class="instagram" href="#"><i class="fa fa-instagram"></i></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product_review">
        <div class="container">
          <div class="tab_container">
            <b-tabs content-class="mt-3" align="center">
              <b-tab title="产品说明 Description " active>
                  <div class="content" v-html="prod_content.content"></div>
              </b-tab>
              <b-tab title="相关下载 Downloads">
                <div class="content">
                  <!-- Start Single Wedget -->
                  <div class="sidebar_widget recent_post mb--60">
                    <h2 class="sidebar_title">MSDS下载</h2>
                    <ul class="sidebar_post">
                      <div v-if="prod_filelist.length==0" >
                        暂无文档 No Data
                      </div>
                      <li v-for="item in prod_filelist" :key="item.title">
                        <div class="post_text">
                          <h4>
                            <b-link :href="'/media/' + item.files" target="_blank">{{ item.title }}</b-link>
                          </h4>
                          <span>{{ item.update_date }}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <!-- End Single Wedget -->
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <!-- End Single Product -->
  </div>
</template>

<script>
export default {
    data () {
        return {
            prod_content: {},
            prod_slideshow: [],
            prod_filelist: [],
            slide: 0,
            sliding: null
        }
    },
    created: function () {
    // 获取产品详情
        function getgoodsdetail (that, params) {
            return that.$axios.get('/api/getgoodsdetail/', {
                params: {
                    pk: params
                }
            })
        }
        // 获取产品轮播页
        function getgoodsslideshow (that, params) {
            return that.$axios.get('/api/getgoodsslideshow/', {
                params: {
                    pk: params
                }
            })
        }
        // 获取产品文档下载列表
        function getgoodsdownloads (that, params) {
            return that.$axios.get('/api/getgoodsdownloads/', {
                params: {
                    pk: params
                }
            })
        }
        var that = this
        var id = that.$route.params.id

        this.$axios
            .all([getgoodsdetail(this, id), getgoodsslideshow(this, id), getgoodsdownloads(this, id)])
            .then(
                this.$axios.spread(function (proContent, proSlideshow, proFilelist) {
                    that.prod_content = proContent.data
                    that.prod_slideshow = proSlideshow.data
                    that.prod_filelist = proFilelist.data
                })
            )
            .catch(function (error) {
                console.log(error)
            })
        document.getElementsByTagName('body')[0].setAttribute('style', 'overflow:scroll')
    },
    methods: {
        goBack () {
            this.$router.go(-1)
        },
        onSlideStart (slide) {
            this.sliding = true
        },
        onSlideEnd (slide) {
            this.sliding = false
        }
    }
}
</script>

<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
      border-bottom: 2px solid #191919;
      color: #000000;
      border-color: none;
    }

.nav-tabs .nav-link {
      border:none;
      border-bottom: 2px solid transparent;
      color: #777777;
      font-family: "Oswald", sans-serif;
      font-size: 20px;
      font-weight: 500;
      padding: 10px 20px;
  }

</style>
